import { SVGProps } from 'react';

const IcDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M4.50049 22C3.81299 22 3.22445 21.7552 2.73486 21.2656C2.24528 20.776 2.00049 20.1875 2.00049 19.5V15.75H4.50049V19.5H19.5005V15.75H22.0005V19.5C22.0005 20.1875 21.7557 20.776 21.2661 21.2656C20.7765 21.7552 20.188 22 19.5005 22H4.50049Z'
      fill='#2D6772'
    />
    <path
      d='M13.2505 2L13.2505 12.1875L16.5005 8.9375L18.2505 10.75L12.0005 17L5.75049 10.75L7.50049 8.9375L10.7505 12.1875L10.7505 2L13.2505 2Z'
      fill='#2D6772'
    />
  </svg>
);
export default IcDownload;
